import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <div className="page-centered">
      <div className="card">
        <h1>Not found</h1>
        <p className="muted">That page does not exist.</p>
        <Link className="btn" to="/">
          Back to the dashboard
        </Link>
      </div>
    </div>
  )
}
